module.exports = __webpack_public_path__ + "img/reset-step-five.824066d2.png";